export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 border border-primary-200/60 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">每日更新 · 实时追踪网红大瓜</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              网红爆料
              <span className="block text-primary-600 mt-1">网红事件最新瓜与热门争议话题合集</span>
            </h1>

            <p className="mt-2 mb-4 text-sm md:text-base text-primary-500/80 font-medium">
              深扒内幕 · 汇总吃瓜 · 一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              专注追踪网红爆料事件最新动态，每日深扒网红内幕爆料大瓜。覆盖直播翻车、人设崩塌、恋情曝光、平台争议等热门话题，为广大吃瓜群众提供最快、最全的网红爆料合集。无论是最新瓜还是经典大事件，这里都是你追瓜吃瓜的第一站。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6 mb-6">
              {[
                { value: '每日更新', label: '内容节奏' },
                { value: '全平台覆盖', label: '监测范围' },
                { value: '深度深扒', label: '内容特色' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-sm md:text-base font-bold text-foreground-900 whitespace-nowrap">{stat.value}</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                type="button"
                onClick={() => scrollTo('#ranking')}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all cursor-pointer whitespace-nowrap"
              >
                查看今日热度榜单
              </button>
              <button
                type="button"
                onClick={() => scrollTo('#carousel')}
                className="px-6 py-3 bg-background-50 hover:bg-secondary-100 text-foreground-700 font-medium text-sm rounded-md border border-secondary-300 transition-all cursor-pointer whitespace-nowrap"
              >
                浏览焦点专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[320px] md:w-[360px] md:h-[420px] lg:w-[420px] lg:h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20atmospheric%20scene%20of%20glowing%20social%20media%20screens%20floating%20in%20warm%20crimson%20and%20amber%20light%2C%20trending%20news%20headlines%20in%20Chinese%20characters%20emerging%20from%20digital%20waves%2C%20cinematic%20composition%20with%20soft%20bokeh%20effects%2C%20mysterious%20digital%20age%20intrigue%2C%20warm%20red%20and%20gold%20color%20palette%2C%20abstract%20data%20visualization%2C%20editorial%20photography%20style%2C%20rich%20dark%20background%20with%20glowing%20highlights%2C%20intense%20yet%20elegant%20mood&width=840&height=960&seq=hero-main-visual&orientation=portrait"
                alt="网红爆料事件最新瓜与热门争议话题合集主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}